/**
 * t722u: make an existing channel private or open from Channel settings (desktop web, phone web and the app). One
 * wording for every surface: the switch, the confirmation (Save / Cancel, one line saying what happens) and the note
 * when the channel follows a project. The API (PATCH /conversations/:id { is_private }) does the checks: people who can
 * manage the channel, channels only, and never a channel that follows its project's "Who can see this project".
 */
export const CHANNEL_PRIVATE_LABEL = 'Private';

/** The one line in the confirmation. */
export function channelPrivacyEffect(makePrivate: boolean): string {
  return makePrivate
    ? 'Only members will be able to see this channel and its messages.'
    : 'Everyone in the workspace will be able to find and join this channel.';
}

export function channelPrivacyTitle(makePrivate: boolean, slug: string | null | undefined): string {
  const name = slug ? `#${slug}` : 'this channel';
  return makePrivate ? `Make ${name} private?` : `Make ${name} open?`;
}

/** Shown beside the switch (turned off) when the channel follows a project. */
export function channelPrivacyProjectNote(projectName: string | null | undefined): string {
  return projectName
    ? `This channel follows the project ${projectName}. Change who can see it in the project’s Settings.`
    : 'This channel follows its project. Change who can see it in the project’s Settings.';
}

/** The system line's text after the person's name ("Daniel McAllister made this channel private"). */
export function channelPrivacySystemLine(isPrivate: boolean): string {
  return isPrivate ? 'made this channel private' : 'made this channel open';
}
